import React, { ReactElement, useMemo } from 'react';
import { Col, Row } from '@nt/dds-react';
import './StatusDetails.css';
import moment from 'moment';
import { ItemsInprogressGridData, StatusType, StepConfig } from '../../../../../utils/types';
import Stepper from '../../../../Stepper';

interface Props {
  entityData: ItemsInprogressGridData;
}

const StatusDetails: React.FC<Props> = ({ entityData }): ReactElement => {
  const commonStepObject = {
    completed: false,
    url: '/',
    buttonLabel: '',
    trackDate: ''
  };
  const stepConfig: StepConfig[] = [
    {
      route: 'draftinprogress',
      name: StatusType.IN_PROGRESS,
      currentStep: 0,
      ...commonStepObject
    },
    {
      route: 'draftsubmitted',
      name: StatusType.SUBMITTED,
      currentStep: 1,
      ...commonStepObject
    },
    {
      route: 'accountrequested',
      name: StatusType.ACCOUNT_REQUESTED,
      currentStep: 2,
      ...commonStepObject
    }
  ];

  const getDateFormat = (stepData: StepConfig, entity: ItemsInprogressGridData) => {
    let date = '';
    if (stepData.name === StatusType.ACCOUNT_REQUESTED && entity.statusAccountRequestedDate) {
      date = moment(entity.statusAccountRequestedDate).format('DD-MMM-YYYY h:mm A');
    } else if (stepData.name === StatusType.SUBMITTED && entity.statusSubmittedDate) {
      date = moment(entity.statusSubmittedDate).format('DD-MMM-YYYY h:mm A');
    } else if (stepData.name === StatusType.IN_PROGRESS && entity.statusDraftCreateDate) {
      date = moment(entity.statusDraftCreateDate).format('DD-MMM-YYYY h:mm A');
    }
    return date;
  };

  const stepsList = useMemo(() => {
    const configList = stepConfig?.map(a => ({ ...a }));
    return configList.map(data => {
      const currentStepObject = configList.find((step: StepConfig) => step.name === entityData.status);
      return {
        ...data,
        completed: data.currentStep < (currentStepObject?.currentStep as number),
        trackDate: getDateFormat(data, entityData)
      };
    });
  }, [entityData]);

  return (
    <div className="entity-status-wrap">
      <Row>
        <Col md={12} className="entity-status">
          <h3>
            New Account opening for {entityData?.legalEntityName} {entityData?.accountName ? '-' : ''}{' '}
            {entityData?.accountName} {entityData?.accountNumber ? ': ' : ''}
            {entityData?.accountNumber}
          </h3>
        </Col>
      </Row>
      <Row className="">
        <Col md={12}>
          <Stepper stepConfig={stepsList} currentRoute={entityData.status.toLowerCase().replace(/\s+/g, '')} />
        </Col>
      </Row>
    </div>
  );
};

StatusDetails.displayName = 'StatusDetails';
export default StatusDetails;
